import { ComponentProps } from "react";
import { ContentGridQuery } from "./ContentGridQuery";
import { useMixContentQuery } from "graphql/generated";
import { ContentSection } from "types/app";
import _ from "lodash";

type ContentGridMixContentQueryProps = Omit<
  ComponentProps<
    typeof ContentGridQuery<MixContentQuery, MixContentQueryVariables>
  >,
  "useQuery" | "extractor" | "updateQuery"
>;

export const ContentGridMixContentQuery = ({
  contentSection,
  variables,
  ...props
}: ContentGridMixContentQueryProps & {
  contentSection: ContentSection;
  variables: MixContentQueryVariables;
}) => {
  return (
    <ContentGridQuery<MixContentQuery, MixContentQueryVariables>
      useQuery={useMixContentQuery}
      extractor={(result) => result.mix_content}
      updateQuery={(previousQueryResult, { fetchMoreResult }) => {
        return {
          mix_content: _.uniqBy(
            [
              ...previousQueryResult.mix_content,
              ...fetchMoreResult.mix_content,
            ],
            (item) => item.id,
          ),
        };
      }}
      contentSection={contentSection}
      variables={variables}
      {...props}
    />
  );
};
